/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Settings_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Open timing and sync settings" |
*
* @param {Timing_Sync_Settings_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_settings_aria_label = /** @type {((inputs?: Timing_Sync_Settings_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Settings_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir les parametres de synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing- und Synchronisierungseinstellungen öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri le impostazioni di temporizzazione e sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте настройки времени и синхронизации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir la configuración de sincronización y tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开定时和同步设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングと同期の設定を開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमिंग और सिंक सेटिंग्स खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra as configurações de sincronização e temporização.")
	return /** @type {LocalizedString} */ ("Open timing and sync settings")
});